export const getInitials = (firstName: string, lastName: string) =>
  `${firstName.substr(0, 1)}${lastName.substr(0, 1)}`;
